import { Role } from '../../role/modals/role-modal';
import { Organisation } from '../../organisation/modals/organisation';
export class User {

    userName: string;
    firstName: string;
    lastName: string;
    emailId: string;
    passwordHash: string;
    organisation: Organisation;
    isActive: boolean;
    createdBy: number;
    createdOn: Date;
    updatedOn:Date;
    updatedBy:number;
    roles: Role[];
    userDetails: UserDetails[];
    city: string;
    country: string;
    description: string;
    userId: any;
    isDemoUser:any;

}

export class UserDetails {
    mobileNumber: any;
    phoneNumber: any;
    address: object;
    isActive: boolean;
    createdBy: number;
    createdOn: Date;
    userDetailsId: string;
}


// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/user/modals/user.modal.ts